import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./CreditHoursModal.css";

const formatDate = (dateString) => {
	return dateString ? dateString.split("T")[0] : "";
};

const overlayStyle = {
	position: "fixed",
	inset: 0,
	background: "rgba(0, 0, 0, 0.55)",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	padding: "24px",
	zIndex: 2147483647,
};

const dialogStyle = {
	position: "relative",
	width: "min(1000px, calc(100vw - 32px))",
	maxHeight: "calc(100vh - 32px)",
	background: "#ffffff",
	borderRadius: "16px",
	boxShadow: "0 24px 60px rgba(0, 0, 0, 0.3)",
	overflow: "hidden",
	zIndex: 2147483647,
};

const contentStyle = {
	padding: "24px",
	maxHeight: "calc(100vh - 32px)",
	overflow: "auto",
	background: "#ffffff",
};

const closeStyle = {
	position: "absolute",
	top: "12px",
	right: "12px",
	width: "34px",
	height: "34px",
	border: "none",
	borderRadius: "999px",
	background: "#d1d5db",
	color: "#374151",
	fontSize: "22px",
	lineHeight: 1,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	cursor: "pointer",
	zIndex: 2147483647,
	padding: 0,
	margin: 0,
};

const CreditHoursModal = ({ isOpen, onClose, details = [] }) => {
	useEffect(() => {
		if (!isOpen) return;

		const prevOverflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";

		return () => {
			document.body.style.overflow = prevOverflow;
		};
	}, [isOpen]);

	if (!isOpen) return null;

	const fundamentalDetails = details.filter(
		(detail) => detail.etp_mstr_comp_crit === "Fundamental",
	);

	const electiveDetails = details.filter(
		(detail) => detail.etp_mstr_comp_crit === "Elective",
	);

	const renderTable = (rows, criticalityType) => {
		const totalCreditHours = rows.reduce((sum, detail) => {
			return sum + Number(detail.etp_mstr_actl_credit_hours || 0);
		}, 0);

		return (
			<div className="credit-hours-modal__section">
				<h3 className="credit-hours-modal__title">
					{criticalityType} Credit Hours Acquired
				</h3>

				<table className="credit-hours-modal__table">
					<thead>
						<tr>
							<th>Core Competency Code</th>
							<th>Criticality</th>
							<th>Actual Credit Hours</th>
							<th>Completion Date</th>
						</tr>
					</thead>
					<tbody>
						{rows.length > 0 ? (
							rows.map((detail, index) => (
								<tr key={`${criticalityType}-${index}`}>
									<td>{detail.etp_mstr_core_comp_code}</td>
									<td>{detail.etp_mstr_comp_crit}</td>
									<td>{detail.etp_mstr_actl_credit_hours || "Pending"}</td>
									<td>
										{formatDate(detail.etp_mstr_completion_date) ||
											"Not Completed"}
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="4">No details available</td>
							</tr>
						)}
						<tr className="credit-hours-modal__total-row">
							<td colSpan="2">Total</td>
							<td>{totalCreditHours}</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	};

	return createPortal(
		<div className="credit-hours-modal__overlay" onClick={onClose}>
			<div
				className="credit-hours-modal__dialog"
				onClick={(e) => e.stopPropagation()}
			>
				<button
					type="button"
					className="credit-hours-modal__close"
					onClick={onClose}
					aria-label="Close credit hours modal"
				>
					&times;
				</button>

				<div className="credit-hours-modal__content">
					{renderTable(fundamentalDetails, "Fundamental")}
					{renderTable(electiveDetails, "Elective")}
				</div>
			</div>
		</div>,
		document.body,
	);
};

export default CreditHoursModal;
